import React from "react";
import PropTypes from "prop-types";
import { loadContactDetails } from "actions/contactActions";
import { Loader, Card, CardSection } from "cxa-components";
import { connect } from "react-redux";
import { FormattedMessage, intlShape, injectIntl } from "react-intl";
import messages from "components/messagesDescription";
import GlobalMessageBoard from "../common/global-message-board";
class ContactPage extends React.Component {
  componentDidMount() {
    const { loadContactDetails, client } = this.props;
    loadContactDetails(client ? { clientName: client } : null);
  }

  render() {
    const { contactUsHtml, intl, rfetchingId, isAuthenticated } = this.props;
    if (rfetchingId || !contactUsHtml) {
      return <Loader />;
    }

    return (
      <div>
        {!isAuthenticated && (
          <div
            style={{
              backgroundColor: "pink",
              position: "sticky",
              left: "0",
              top: "0",
              zIndex: "100",
            }}
          >
            <GlobalMessageBoard />
          </div>
        )}
        <div className="o-layout">
          <div className="o-layout__contact-page">
            <div className="o-layout__item u-1/2@desktop">
              <Card>
                <CardSection>
                  <h3>
                    <FormattedMessage {...messages.contactUsDescription} />
                  </h3>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: intl.formatMessage({
                        id: contactUsHtml,
                        defaultMessage: contactUsHtml,
                        values: messages.contactDescription.values,
                      }),
                    }}
                  />
                </CardSection>
              </Card>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ContactPage.propTypes = {
  error: PropTypes.object,
  loadContactDetails: PropTypes.func,
  contactUsHtml: PropTypes.string,
  client: PropTypes.string,
  intl: intlShape.isRequired,
};

const mapStateToProps = store => {
  return {
    error: store.error,
    contactUsHtml: store.contact.contactUsHtml,
    client: store.app.clientName,
    rfetchingId: store.localization.rfetchingId,
    isAuthenticated: store.login.isAuthenticated,
  };
};

const mapDispatchToProps = {
  loadContactDetails,
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(ContactPage));



// WEBPACK FOOTER //
// ./components/employee/ContactPage.js